export * from './InvestorContactUs'
export * from './InvestorHeadline'
export * from './InvestorHowItWorks'
export * from './InvestorKpis'
export * from './InvestorModal'
export * from './InvestorPartners'
export * from './InvestorServices'
export * from './InvestorWhatWeDo'
